import { connect } from 'react-redux';
import SelectorsListSection from './SelectorsList';

const mapState = state => ({
  selectorsListLoading: state.loadingManagement.supplierAuthorizations.selectorsListLoading,
});

export default connect(mapState)(SelectorsListSection);
